import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { Section } from './Shared';
export function Guarantee() {
  return <div className="bg-cream" data-id="element-85">
      <Section className="max-w-3xl" data-id="element-86">
        <div className="bg-sage-light/30 border border-sage/30 rounded-3xl shadow-sm p-8 md:p-12 text-center relative overflow-hidden" data-id="element-87">
          {/* Soft decorative blobs */}
          <div className="absolute -top-8 -left-8 w-32 h-32 bg-gold-light/40 rounded-full blur-2xl -z-0" data-id="element-88"></div>
          <div className="absolute -bottom-8 -right-8 w-40 h-40 bg-sage/20 rounded-full blur-3xl -z-0" data-id="element-89"></div>

          <div className="relative z-10 flex flex-col items-center" data-id="element-90">
            <div className="bg-white w-20 h-20 rounded-full flex items-center justify-center mb-6 shadow-sm border border-sage/20" data-id="element-91">
              <ShieldCheck className="w-10 h-10 text-cta" strokeWidth={1.8} data-id="element-92" />
            </div>

            <h2 className="font-playfair text-3xl md:text-4xl text-charcoal leading-tight mb-3" data-id="element-93">
              Tu compra está protegida
            </h2>

            <p className="font-playfair italic text-lg md:text-xl text-sage-dark mb-6" data-id="element-94">
              Garantía de satisfacción de 7 días
            </p>

            <p className="text-charcoal-light text-base md:text-lg leading-relaxed max-w-xl" data-id="element-95">
              Si en 7 días sentís que la guía no era para vos, te devolvemos el
              dinero sin preguntas. Queremos que empieces sin miedo.
            </p>
          </div>
        </div>
      </Section>
    </div>;
}